import React from 'react';
import {
    Datagrid,
    DateField,
    TextField,
    Filter,
    List,
    SearchInput,
    // ReferenceField,
    ReferenceInput,
    AutocompleteInput,
} from 'react-admin';
import CodeField from './fields/CodeField';
// import FullNameField from '../fields/users/FullNameField';
import CourseStatutField from './fields/CourseStatutField';
import CourseStatutInput from './inputs/CourseStatutInput';
import PriceField from '../fields/common/PriceField';
const CourseFilter = (props: any) => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
        <CourseStatutInput
            source="statut"
            label="resources.courses.fields.statut"
        />
        <ReferenceInput
            source="user"
            label="resources.courses.fields.user"
            reference="users"
        >
            <AutocompleteInput optionText="name" emptyText="Tout" resettable />
        </ReferenceInput>
        <ReferenceInput
            source="driver"
            label="resources.courses.fields.driver"
            reference="livreurs"
        >
            <AutocompleteInput optionText="name" emptyText="Tout" resettable />
        </ReferenceInput>
    </Filter>
);
const CourseList = (props: any) => {
    return (
        <List
            {...props}
            filters={<CourseFilter />}
            sort={{ field: 'created_at', order: 'DESC' }}
            perPage={10}
            exporter={false}
            bulkActionButtons={false}
            hasCreate={false}
        >
            <Datagrid optimized rowClick="show">
                <CodeField
                    source="code_str"
                    label="resources.courses.fields.code"
                />
                <DateField
                    source="created_at"
                    type="date"
                    label="resources.courses.fields.created_at"
                    showTime
                    options={{
                        hourCycle: 'h23',
                    }}
                />
                <PriceField
                    source="payed_price"
                    label="resources.courses.fields.payed_price"
                />

                <TextField
                    addLabel={true}
                    label="resources.courses.fields.client"
                    source="user.name"
                />
                <TextField
                    addLabel={true}
                    label="resources.courses.fields.driver"
                    source="livreur.name"
                />

                <TextField
                    addLabel={true}
                    label="resources.courses.fields.from_address1"
                    source="from_address1"
                />
                <TextField
                    addLabel={true}
                    label="resources.courses.fields.to_address1"
                    source="to_address1"
                />

                <CourseStatutField
                    source="statut"
                    label="resources.courses.fields.statut"
                />
            </Datagrid>
        </List>
    );
};

export default CourseList;
